import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';

import { PermissionsService } from '../permissions/permissions.service';
import { GlobalService } from '@services/global/global.service';

@Injectable()
export class UserCheckAndSchoolAccessGuardService {
    constructor(
        private router: Router,
        private permissionsService: PermissionsService,
        private globalService: GlobalService,
    ) {}

    public canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
        const user = this.globalService.user;

        const id =
            route.params.coach_id ||
            route.params.user_id ||
            route.params.profile_id;

        if (user._id === id) {
            return true;
        } else {
            return (
                this.permissionsService.checkPermission({
                    name: 'users_profile_view',
                    schools: [user.school._id],
                }) || this.router.parseUrl('/error/403')
            );
        }
    }
}
